<template>
<div class="chapter">
<div class="inner_page">
<h2 id="pgepubid00009">THE BOWL</h2>
<p class="poem">Some master-craftsman, maker of porcelains, to the Emperor, the Son of Heaven,<br class="calibre3"/>
  Having attained the paradise of artists, who mould in life and fire,<br class="calibre3"/>
  Fashioned this day:<br class="calibre3"/>
<br class="calibre3"/>
  A bowl blue as the iris within the sacred gardens,<br class="calibre3"/>
  Based with a low design of brown bare hills,<br class="calibre3"/>
  A pine or two new-tipped with tender needles,<br class="calibre3"/>
  With oak buds, pink and saffron,<br class="calibre3"/>
  And birds red, brown, and blue.<br class="calibre3"/>
<br class="calibre3"/>
  Into this bowl, exquisite and perishable,<br class="calibre3"/>
  The Patron of all artists heaps light and more light;<br class="calibre3"/>
  Then holding high the brimming chalice, quaffs,<br class="calibre3"/>
  And folds it in his altar-cloth of stars.<br class="calibre3"/></p>
<p class="valediction"><em class="smcap">Carl H. Grabo</em>. (<i class="calibre4">From the Nation</i>.)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?25f7df48